<div class="flex items-center justify-center">
  <div class="bet-button-container">
    <button
      *ngFor="let coinValue of coinsValue"
      class="bet"
      (click)="onEasyPickClick(coinValue.value)"
      [disabled]="!_betService.allowBet"
    >
      <div class="coin-container" [class.active]="_betService.betValue === coinValue.value"></div>
      <div class="inner-circle">
        <div class="circle-text {{ coinValue.fontSize }}">{{ coinValue.text }}</div>
      </div>
    </button>
  </div>
</div>

<div class="bet-input">
  <input
    [disabled]="!_betService.allowBet"
    placeholder="Type in your custom bet amount here."
    type="number"
    min="0"
    [(ngModel)]="_betService.betValue"
    appTwoDigitDecimalNumber
  />
</div>

<div class="multiplier-button-container">
  @for (betOption of _betService.betOptions; track betOption.type) {
    <button
      [disabled]="disableBet($index) || !_betService.allowBet"
      class="bet-option btn-primary-v3"
      (click)="placeBet(betOption)"
    >
      <div>{{ betOption.label }}</div>
      <div class="!lowercase">x{{ betOption.multiplier }}</div>
    </button>
  }
</div>
